<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <c-table :table-data="data" :fields="fields" caption="Inventory Report"></c-table>
      </b-col>
    </b-row><!--/.row-->
  </div>
</template>

<script>
  import router from '../../router'
  import cTable from './Table.vue'

  export default {
    components: {
      cTable,
      router
    },
    name: 'forms',
    data () {
      return {
        data: [{
          pMake: 'Motorola',
          pMode: 'MB100K-2HAXH-F',
          sernm: 'G12FM02042604940',
          quant: 7,
          status: 'Success'
        },
          {
            pMake: 'Motorola',
            pMode: 'MB87SG',
            sernm: 'G12FM02143604624',
            quant: 12,
            status: 'Success'
          },
          {
            pMake: 'C-Cor',
            pMode: 'FNB75CDL-L0014',
            sernm: '1969696',
            quant: 0,
            status: 'Inactive'
          },
          {
            pMake: 'Motorola',
            pMode: 'MB100K-2HAXH-F',
            sernm: 'G12FM02042604940',
            quant: 2,
            status: 'Success'
          }],
        fields: [
          {key: 'pMake', label: 'Manufacturer', sortable: true, style: 'width: 250px'},
          {key: 'pMode', label: 'Model'},
          {key: 'sernm', label: 'Serial#'},
          {key: 'quant', label: 'Quantity'},
          {key: 'status', label: 'In stock', sortable: true, tdClass: 'complaintClass'}
        ],
      }
    },
    methods: {
    },
    mounted () {
    }
  }
</script>

<style scoped>
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s;
  }
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
</style>
